import "./SurveyManagement.css";

import * as XLSX from "xlsx";

import React, { useContext, useEffect, useState } from "react";
import {
    activateSurvey,
    deActivateSurvey,
    deleteSurvey,
    extendSurvey,
    getAllSurveys,
    getDistributionList,
    getReminderTemplate,
    getSurveyDataForExcel,
    getSurveyRecipients,
    publishSurvey,
    rePublishSurvey,
    reminderSurvey,
    uploadNewSurvey
} from "../../services/survey/survey.service";
import { getUserSurveysQuestions } from "../../services/survey/survey-user";
import { DataTableComponent } from "../common/TableComponent/DataTableComponent";
import IconButton from "../common/IconButton/IconButton";
import Loader from "../common/Loader/Loader";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import PlusIcon from "../../assets/PlusIcon";
import DownloadIcon from "../../assets/Download.svg";
import { SurveyContext } from "../../utils/SurveyContext";
import SurveyDashboard from "./SurveyDashboard";
import { formatDate } from "../../utils/dateFormat";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import validateFields from "../../utils/ValidationInput";
import { getSafeHtmlFromDb } from "../../utils/sanitizeSvgFile";

const SurveyManagement = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    // Column definitions
    const columns = [
        {
            name: t("surveyTitle"),
            field: "surveyTitle",
            selector: (row) => row.surveyTitle,
            sortable: true,
            width: "300px",
        },
        // { name: "Owner", field: "owner" },
        {
            name: t("createdDate"),
            field: "createdDate",
            selector: (row) => row.createdDate,
            cell: (row) =>
                row.createdDate ? formatDate(row.createdDate) : "N/A",
            sortable: true,
            width: "150px",
        },
        {
            name: t("startDate"),
            field: "startDate",
            selector: (row) => row.startDate,
            cell: (row) => (row.startDate ? formatDate(row.startDate) : "N/A"),
            sortable: true,
            width: "150px",
        },
        {
            name: t("endDate"),
            field: "endDate",
            selector: (row) => row.endDate,
            cell: (row) => (row.endDate ? formatDate(row.endDate) : "N/A"),
            sortable: true,
            width: "150px",
        },
        {
            name: t("description"),
            field: "description",
            selector: (row) => row.description,
            sortable: true,
            width: "300px",
        },
        {
            name: t("status"),
            field: "status",
            selector: (row) => row.status,
            sortable: true,
            width: "150px",
        },
        {
            name: t("published"),
            field: "isPublished",
            selector: (row) => row.isPublished,
            sortable: true,
            width: "100px",
        },
    ];

    const surveyFields = [
        {
            fieldName: t("surveyTitle"),
            type: "input",
            name: "surveyTitle",
            readOnly: true,
        },
        { fieldName: t("startDate"), type: "datepicker", name: "startDate", required: true },
        { fieldName: t("endDate"), type: "datepicker", name: "endDate", required: true },
        {
            fieldName: t("markSurveyPublic"),
            type: "checkbox",
            name: "publicSurvey",
        },
        {
            fieldName: t("surveyRecipients"),
            name: "recipients",
            type: "multiselect",
            placeholder: t("multiselectDistributionList"),
            options: [],
            isFieldDisabled: false,
            required: true
        },
        { fieldName: t("emailSubject"), type: "inputWithCount", name: "emailSubject", required: true },
        { fieldName: t("emailText"), type: "textareaWithCount", name: "emailText", required: true },
    ];

    const rePublishSurveyFields = [
        {
            fieldName: t("surveyTitle"),
            type: "input",
            name: "surveyTitle",
            readOnly: true,
        },
        {
            fieldName: t("existingRecipients"),
            type: "textarea",
            name: "surveyRecipients",
            placeholder: t("enterEmailAddresses"),
            isFieldDisabled: true,
        },
        {
            fieldName: t("addRecipients"),
            type: "textarea",
            name: "newSurveyRecipients",
            placeholder: t("enterEmailAddresses"),
            isFieldDisabled: false,
            required: true
        },
        {
            fieldName: t("emailSubject"),
            type: "inputWithCount",
            name: "emailSubject",
            required: true
        },
        {
            fieldName: t("emailText"),
            type: "textareaWithCount",
            name: "emailText",
            required: true
        },
    ];

    const extensionFields = [
        {
            fieldName: t("surveyTitle"),
            type: "input",
            name: "surveyTitle",
            readOnly: true,
        },
        { fieldName: t("startDate"), type: "datepicker", name: "startDate", required: true },
        { fieldName: t("endDate"), type: "datepicker", name: "endDate", required: true },
    ];

    const languageField = {
        fieldName: t("language"),
        type: "dropdown",
        name: "language",
        options: [
            { label: t("selectlanguage"), value: "" },
            { label: t("japanese"), value: "2" },
            { label: t("simplifiedChinese"), value: "19" },
        ],
        required: true,
    };

    const uploadTemplateField = {
        fieldName: t("uploadTemplate"),
        type: "file",
        name: "assessmentFile",
        showUploadIcon: true,
        required: true,
    };

    let surveyTitleField = {
        fieldName: t("surveyTitle"),
        type: "dropdown",
        name: "surveyTitle",
        options: [
            { label: t("selectSurveyTitle"), value: "" },
        ],
    };

    const [surveyFormData, setSurveyFormData] = useState({
        surveyTitle: "",
        startDate: "",
        endDate: "",
        recipients: "",
        email: "",
        publicSurvey: false,
        emailText: "",
        emailSubject: "",
    });

    const [rePublishsurveyFormData, setRePublishsurveyFormData] = useState({
        surveyRecipients: "",
        newSurveyRecipients: "",
        emailText: "",
        emailSubject: "",
        surveyTitle: "",
    });
    const [existingRecipients, setExistingRecipients] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({
        surveyTitle: "",
        fieldsData: [],
        buttons: [],
    });
    const [modalText, setModalText] = useState("");
    const [loading, setLoading] = useState(false);
    const [distributionList, setDistributionList] = useState([]);
    const [payloadDistributionList, setPayloadDistributionList] = useState([]);
    const [selectedAction, setSelectedAction] = useState("");
    const [publishModalButtons, setPublishModalButtons] = useState([]);
    const [selectedTableRow, setSelectedTableRow] = useState(null);
    const [surveyPublishFields, setSurveyPublishFields] =
        useState(surveyFields);
    const [surveyExtentionFields, setSurveyExtentionFields] =
        useState(extensionFields);
    const { surveyTab, setSurveyTab } = useContext(SurveyContext);
    const [surveyId, setSurveyId] = useState(0);
    const [surveyData, setSurveyData] = useState([]);
    const [isUploadModalOpen, setUploadModalOpen] = useState(false);
    const [selectedLang, setSelectedLang] = useState("");
    const [surveyTemplate, setSurveyTemplate] = useState([]);
    const [selectedSurveyId, setSelectedSurveyId] = useState('');
    const [selectedFile, setSelectedFile] = useState('');
    const [languageMasterId, setLanguageMasterId] = useState('');
    const [rowSurveyData, setRowSurveyData] = useState('');
    const [glbLanguageId, setGlbLanguageId] = useState(1);
    useEffect(() => {
        fetchAllSurveys();
        fetchDistributionList();
    }, []);

    const fetchReminderTemplate = async (id, languageId) => {
        try {
            setLoading(true);
            const reminderTemplate = await getReminderTemplate(id, languageId);
            formatReminderText(reminderTemplate?.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const formatReminderText = (text) => {
        const withSurveyLink = text.replaceAll("{SurveyLink}", process.env.REACT_APP_OKTA_LOGOUT_REDIRECT_URI);
        console.log(withSurveyLink, text);
        const formattedText = (
            <div
                style={{ whiteSpace: "pre-line" }}
            dangerouslySetInnerHTML={{ __html: withSurveyLink }}/>
        );
        setModalText(formattedText);
    };

    const fetchAllSurveys = async () => {
        try {
            setLoading(true);
            const templatesResult = await getAllSurveys();
            const updatedData = templatesResult?.data.map((item) => ({
                ...item,
            }));
            setTableData(updatedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

const getParentRows = (allRows) => {
    const seen = new Set();
    const parents = [];
    allRows.forEach(row => {
        if (!seen.has(row.surveyId)) {
            // Prefer English as parent if available
            const english = allRows.find(r => r.surveyId === row.surveyId && r.languageMasterId === 1);
            if (english && !parents.some(p => p.surveyId === english.surveyId)) {
                parents.push(english);
            } else {
                parents.push(row);
            }
            seen.add(row.surveyId);
        }
    });
    return parents;
};

    const fetchSurveyTemplates = async () => {
        try {
            setLoading(true);
            const filteredSurveys = tableData.filter(
                (survey) =>
                        survey.languageMasterId === 1 &&
                        survey.status?.toLowerCase() === "active" &&
                        survey.isPublished === false
            );
            console.log("Filtered Surveys:", filteredSurveys);
            surveyTitleField = {
                    ...surveyTitleField,
                    fieldName: t("surveyTitle"),
                    type: "dropdown",
                    name: "surveyTitle",
                    options: [
                        { label: t("selectSurveyTitle"), value: "" },
                        ...filteredSurveys.map(item => ({
                            label: item.surveyTitle,
                            value: item.surveyId
                        }))
                    ],
                    required: true
            };
            setSurveyTemplate(surveyTitleField);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchDistributionList = async () => {
        try {
            setLoading(true);
            const groupResult = await getDistributionList();
            const updatedData = groupResult?.data.map((item) => ({
                ...item,
                label: item.title,
                value: item.id,
            }));
            setDistributionList(updatedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSurveyQuestions = async (rowData) => {
            if (rowData.surveyId) {
                setLoading(true);
                try {
                    const response = await getUserSurveysQuestions(rowData.surveyId, rowData.languageMasterId); // Fetch survey questions using the API;
                    if (response.statusCode === 200 && response.data) {
                        const sheet1Data = [
                            {
                                Title: rowData.surveyTitle,
                                Description: rowData.description,
                                PrivacyNotice: rowData.privacyNote,
                            },
                        ];

                        // Create worksheet
                        const ws1 = XLSX.utils.json_to_sheet(sheet1Data);

                        // Make headers bold
                        ["A1", "B1", "C1"].forEach((cell) => {
                            if (!ws1[cell]) return;
                            ws1[cell].s = {
                                font: { bold: true },
                            };
                        });
                        // Sheet 2: Example (customize as needed)
                    // 1. Get all unique option keys
                    const allOptionKeys = Array.from(
                        new Set(
                            response.data.flatMap(q => {
                                try {
                                    const opts = JSON.parse(q.options);
                                    return Object.keys(opts);
                                } catch {
                                    return [];
                                }
                            })
                        )
                    );

                    // 2. Prepare header row
                    const header = [
                        "ID",
                        "Section",
                        "QuestionText",
                        ...allOptionKeys.map(key => `Option-${key}`)
                    ];

                    // 3. Prepare sheet data
                    const sheetData = response.data.map(q => {
                        let opts = {};
                        try {
                            opts = JSON.parse(q.options);
                        } catch {}
                        return {
                            ID: q.questionId,
                            Section: q.sectionTitle,
                            QuestionText: q.questionText,
                            ...Object.fromEntries(
                                allOptionKeys.map(key => [`Option-${key}`, opts[key] || ""])
                            )
                        };
                    });

                    // 4. Convert to array of arrays for xlsx
                    const rows = [
                        header,
                        ...sheetData.map(row =>
                            header.map(col => row[col] !== undefined ? row[col] : "")
                        )
                    ];

                    // 5. Export to Excel
                    const ws2 = XLSX.utils.aoa_to_sheet(rows);

                        // Create workbook and append sheets
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws1, "Survey");
                        XLSX.utils.book_append_sheet(wb, ws2, "SurveyQuestions");

                        // Download Excel file
                        XLSX.writeFile(wb, "Survey_Template.xlsx");
                    }
                    setLoading(false);
                } catch (error) {
                    console.error("Failed to fetch survey questions:", error);
                    setLoading(false);
                }
            }
    };

    // Handle action button clicks (Activate, Deactivate, Delete, Publish, Reminder)
    const handleAction = (actionType, row, rowIndex) => {
        // setSurveyPublishFields([])
        const modalData = getModalData(actionType, rowIndex, row);
        setModalContent(modalData);
        setModalOpen(true);
    };

    const getModalData = (actionType, rowIndex, row) => {
        setSelectedAction(actionType);
        const selectedSurvey = row;
        let title = "";
        let fields = [];
        let buttons = [];

        const confirmButton = (label) => (
            <button
                className="SurveyModalButton"
                onClick={() =>
                    handleConfirmAction(
                        actionType,
                        rowIndex,
                        row,
                        surveyFormData
                    )
                }
            >
                {label}
            </button>
        );

        const cancelButton = (
            <button
                className="SurveyModalButton SurveyCancel"
                onClick={() => setModalOpen(false)}
            >
                {t("cancel")}
            </button>
        );

        if (actionType === "Activate") {
            title = t("activateSurvey");
            setModalText(
                `${t("areYouSureWantToActivate")} "${selectedSurvey.surveyTitle}"?`
            );
            buttons = [confirmButton(t("activate")), cancelButton];
        } else if (actionType === "Deactivate") {
            title = t("deactivateSurvey");
            setModalText(
                `${t("areYouSureWantToDeactivate")} "${selectedSurvey.surveyTitle}"?`
            );
            buttons = [confirmButton(t("deactivate")), cancelButton];
        } else if (actionType === "Delete") {
            title = t("deleteSurvey");
            setModalText(
                `${t("areYouSureWantToDelete")} "${selectedSurvey.surveyTitle}"?`
            );
            buttons = [confirmButton(t("delete")), cancelButton];
        } else if (actionType === "Reminder") {
            title = t("sendReminder");
            fetchReminderTemplate(selectedSurvey?.surveyId, selectedSurvey?.languageMasterId);
            // setModalText(`Send a reminder for "${selectedSurvey.surveyTitle}"?`);
            buttons = [confirmButton(t("send")), cancelButton];
        } else if (actionType === "Publish") {
        }

        return { title, fields, buttons };
    };

    const onDeleteSurvey = async (row) => {
        setLoading(true);
        let payload = {
            surveyId: row?.surveyId,
            languageId: row?.languageMasterId,
        };
        await deleteSurvey(payload).then((response) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                toast.success(
                    t("surveyDeletedSuccess", { surveyTitle: row?.surveyTitle }),
                    {
                        position: "top-center",
                    }
                );
            }
            setLoading(false);
            fetchAllSurveys();
        });
    };

    const onSendReminder = async (row) => {
        setLoading(true);
        let payload = {
            surveyId: row?.surveyId,
        };
        const surveyLink = window.location.host;
        await reminderSurvey(payload, surveyLink).then((response) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                toast.success(
                    t("surveyReminderSentSuccess", { surveyTitle: row?.surveyTitle }),
                    {
                        position: "top-center",
                    }
                );
            } else {
                toast.error(
                    t("surveyNoRecipientsError", { surveyTitle: row?.surveyTitle }),
                    {
                        position: "top-center",
                    }
                );
            }
            setLoading(false);
            fetchAllSurveys();
        });
    };

    const onActivateSurvey = async (row) => {
        setLoading(true);
        let payload = {
            surveyId: row?.surveyId,
        };
        await activateSurvey(payload).then((response) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                toast.success(
                    t("surveyActivatedSuccess", { surveyTitle: row?.surveyTitle }),
                    {
                        position: "top-center",
                    }
                );
            }
            setLoading(false);
            fetchAllSurveys();
        });
    };

    const onDeActivateSurvey = async (row) => {
        setLoading(true);
        let payload = {
            surveyId: row?.surveyId,
        };
        await deActivateSurvey(payload).then((response) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                toast.success(
                    t("surveyDeactivatedSuccess", { surveyTitle: row?.surveyTitle }),
                    {
                        position: "top-center",
                    }
                );
            }
            setLoading(false);
            fetchAllSurveys();
        });
    };

    const convertToISOString = (date) => {
        const offset = date?.getTimezoneOffset();
        const adjustedDate = new Date(date?.getTime() - offset * 60000);
        return adjustedDate.toISOString();
    };

    const handleDateChange = (date, name) => {
        const updatedDate = new Date(date);
        updatedDate.setHours(0, 0, 0, 0);

        if (date !== null) {
            setSurveyFormData((prevData) => ({
                ...prevData,
                [name]: convertToISOString(updatedDate),
            }));
        }
    };

    const validateEmailsWithSemicolons = (emails) => {
        const trimmedEmails = emails.trim();

        if (!trimmedEmails) {
            return false;
        }

        // Check for invalid characters immediately following a semicolon (e.g., ;., ;@, etc.)
        // This checks for any non-email-like character after a semicolon
        if (/;[^\w@]/.test(trimmedEmails)) {
            return false; // Invalid character after semicolon (e.g., ;., ;@, etc.)
        }

        // Split emails by semicolon
        const emailArray = trimmedEmails
            .split(";")
            .map((email) => email.trim())
            .filter((email) => email !== ""); // Remove empty entries

        // If there are no emails after splitting, return false
        if (emailArray.length === 0) {
            return false;
        }

        // Check for double semicolons or empty entries in the original string
        if (trimmedEmails.includes(";;")) {
            return false; // Double semicolon found, which means an empty entry
        }

        // Validate each email using a regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailArray.every((email) => emailRegex.test(email));
    };

    const onPublishSurvey = async () => {
        setLoading(true);

        
        // Required fields with types (text or email)
        const requiredFields = [
            {
                label: t("startDate"),
                key: "Start Date",
                type: "date",
                value: surveyFormData.startDate,
            },
            { label: t("endDate"), key: "End Date", type: "date", value: surveyFormData.endDate },
        ];

        if (surveyFormData.publicSurvey === false) {
            requiredFields.push(
                {
                    label: t("emailSubject"),
                    key: "Email Subject",
                    type: "text",
                    name: "emailSubject",
                    charLength: 255,
                    value: surveyFormData.emailSubject,
                },
                {
                    label: t("emailText"),
                    key: "Email Text",
                    type: "text",
                    name: "emailText",
                    charLength: 8000,
                    value: surveyFormData.emailText,
                }
            );
        }

        const isValid = validateFields(
            surveyFormData,
            requiredFields,
            "byValue"
        );
        if (!isValid) {
            setLoading(false);
            return;
        }

        if (surveyFormData.publicSurvey === false) {
            if (
                // surveyFormData.email.length === 0 &&
                payloadDistributionList.length === 0
            ) {
                toast.error(t("selectDistributionList"), {
                    position: "top-center",
                });
                setLoading(false);
                return;
            }
        }

        let payload = {
            startDate: surveyFormData.startDate,
            endDate: surveyFormData.endDate,
            surveyLink: window.location.host,
        };

        if (surveyFormData.publicSurvey === true) {
            payload.isCoded = true;
            // payload.emailText = surveyFormData.emailText;
            // payload.emailSubject = surveyFormData.emailSubject;
        } else {
            // payload.surveyRecipients = surveyFormData.email;
            payload.distributionListIds = payloadDistributionList;
            // payload.emailText = surveyFormData.emailText.replace(/\n/g, "(br)");
            payload.emailText = surveyFormData.emailText;
            payload.emailSubject = surveyFormData.emailSubject;
        }

        await publishSurvey(payload, selectedTableRow?.surveyId).then(
            (response) => {
                if (
                    response?.statusCode === 200 ||
                    response?.statusCode === 201
                ) {
                    toast.success(
                        t("surveyPublishedSuccess", { surveyTitle: surveyFormData?.surveyTitle }),
                        {
                            position: "top-center",
                        }
                    );
                    fetchAllSurveys();
                    clearPublishFields();
                    setModalOpen(false);
                }
                setLoading(false);
            }
        );
    };

    const onRePublishSurvey = async () => {
        setLoading(true);

        // Required fields with types (text or email)
        const requiredFields = [
            {
                label: t("recipients"),
                key: "Recipients",
                type: "",
                name: "newSurveyRecipients",
                value: rePublishsurveyFormData.newSurveyRecipients,
            },
            {
                label: t("emailSubject"),
                key: "Email Subject",
                type: "text",
                name: "emailSubject",
                charLength: 255,
                value: rePublishsurveyFormData.emailSubject,
            },
            {
                label: t("emailText"),
                key: "Email Text",
                type: "text",
                name: "emailText",
                charLength: 8000,
                value: rePublishsurveyFormData.emailText,
            },
        ];

        const isValid = validateFields(
            rePublishsurveyFormData,
            requiredFields,
            "byValue"
        );
        if (!isValid) {
            setLoading(false);
            return;
        }

        let payload = {
            emailText: rePublishsurveyFormData.emailText,
            emailSubject: rePublishsurveyFormData.emailSubject,
            // surveyRecipients: newEmails.join(";"),
            surveyRecipients: rePublishsurveyFormData.newSurveyRecipients,
            surveyLink: window.location.host,
        };

        await rePublishSurvey(payload, selectedTableRow?.surveyId).then(
            (response) => {
                if (
                    response?.statusCode === 200 ||
                    response?.statusCode === 201
                ) {
                    toast.success(
                        t("surveyRepublishedSuccess", { surveyTitle: surveyFormData?.surveyTitle }),
                        {
                            position: "top-center",
                        }
                    );
                    fetchAllSurveys();
                    clearPublishFields();
                    setModalOpen(false);
                }
                setLoading(false);
            }
        );
    };

    const clearPublishFields = () => {
        setSurveyFormData({
            surveyTitle: "",
            startDate: "",
            endDate: "",
            recipients: "",
            email: "",
            publicSurvey: false,
            emailText: "",
            emailSubject: "",
        });

        setRePublishsurveyFormData({
            surveyTitle: "",
            surveyRecipients: "",
            newSurveyRecipients: "",
            emailText: "",
            emailSubject: "",
        });
        setPayloadDistributionList([]);
    };

    const onClosePublishModal = () => {
        clearPublishFields();
        setModalOpen(false);
    };

    // Confirm action in modal
    const handleConfirmAction = (actionType, rowIndex, row, data) => {
        if (actionType === "Activate") {
            onActivateSurvey(row);
        } else if (actionType === "Deactivate") {
            onDeActivateSurvey(row);
        } else if (actionType === "Delete") {
            onDeleteSurvey(row);
        } else if (actionType === "Reminder") {
            onSendReminder(row);
        }
        setModalOpen(false);
    };

    const handleInputChange = (target, name) => {
        if (name === "checkbox") {
            setSurveyFormData((prev) => ({
                ...prev,
                [target.name]: target.checked,
            }));

            if (target.checked === true) {
                const fields = surveyPublishFields.filter(
                    (field) =>
                        field.name !== "recipients" &&
                        field.name !== "email" &&
                        field.name !== "emailText" &&
                        field.name !== "emailSubject"
                );
                setSurveyFormData((prev) => ({
                    ...prev,
                    emailText: "",
                    emailSubject: "",
                    recipients: [],
                }));
                setSurveyPublishFields(fields);
                toast.info("You are about to publish a survey with open link.");
            } else {
                let formFields = surveyFields;
                const updatedFields = formFields.map((field) => {
                    if (field.name === "recipients") {
                        return {
                            ...field,
                            options: distributionList.filter(
                                (item) =>
                                    item.email !== "" && item.isActive === true
                            ),
                        };
                    }
                    return field;
                });
                setSurveyPublishFields(updatedFields);
            }
        } else {
            toast.dismiss();
            if (target.name === "emailText" && target.value.length > 8000) {
                toast.error(t("emailTextExceedsMaxLengthError", { number: 8000 }), {
                    position: "top-center",
                    theme: "dark",
                });
                return;
            }

            if (target.name === "emailSubject" && target.value.length > 255) {
                toast.error(t("emailSubjectExceedsMaxLengthError", { number: 255 }), {
                    position: "top-center",
                    theme: "dark",
                });
                return;
            }

            setSurveyFormData((prev) => ({
                ...prev,
                [target.name]: target.value,
            }));

            setRePublishsurveyFormData((prev) => ({
                ...prev,
                [target.name]: target.value,
            }));
        }
    };

    const goToSurveyPage = () => {
        navigate("/admin/survey/survey-page");
    };

    const onChangeMultiselect = (data, type) => {
        setSurveyFormData((prevData) => ({
            ...prevData,
            recipients: data,
        }));
        const selectedIds = data.map((item) => item.value);
        setPayloadDistributionList(selectedIds);
    };

    const handlePublishAction = (actionType, row, rowIndex) => {
        setSurveyPublishFields(surveyFields);
        setSelectedAction(actionType);
        setModalText("");
        setModalOpen(true);
        setSelectedTableRow(row);

        let formFields = surveyFields;
        const updatedFields = formFields.map((field) => {
            if (field.name === "recipients") {
                return {
                    ...field,
                    options: distributionList.filter(
                        (item) => item.email !== "" && item.isActive === true
                    ),
                };
            }
            return field;
        });

        setSurveyPublishFields(updatedFields);

        // Populate surveyFormData with the selected survey's data
        setSurveyFormData((prevData) => ({
            ...prevData,
            surveyTitle: row?.surveyTitle,
            publicSurvey: false,
        }));
    };

    const handleRePublishAction = async (actionType, row, rowIndex) => {
        setSurveyPublishFields(surveyFields);
        setSelectedAction(actionType);
        setModalText("");
        setModalOpen(true);
        setSelectedTableRow(row);

        // Fetch survey recipients for the selected survey
        await getSurveyRecipients(row?.surveyId).then((response) => {
            if (response?.statusCode === 200) {
                const recipients = response?.data?.map((item, index) => ({
                    label: item,
                    value: index,
                }));
                setExistingRecipients(recipients.map((r) => r.label)); // Store existing emails
                setRePublishsurveyFormData((prevData) => ({
                    ...prevData,
                    surveyRecipients: recipients
                        .map((r) => r.label)
                        .join("; ")
                        .trim(),
                    surveyTitle: row?.surveyTitle,
                }));
            } else {
                toast.error(t("failedToFetchSurveyRecipients"), {
                    position: "top-center",
                });
            }
        });
    };

    const onCopyLink = async (row, rowIndex) => {
        const surveyId = row?.surveyId;
        const code = row?.code;
        const languageId = row?.languageMasterId;
        const surveyLink = `${window.location.origin}/survey/${surveyId}/${code}/${languageId}`;
        await navigator.clipboard.writeText(surveyLink);
        toast.success(t("surveyLinkCopied"), {
            position: "top-center",
        });
    };

    const handleSurveyExtention = (actionType, row) => {
        setSurveyExtentionFields(extensionFields);
        setSelectedAction(actionType);
        setModalText("");
        setModalOpen(true);
        setSelectedTableRow(row);

        // Populate surveyFormData with the selected survey's data
        setSurveyFormData((prevData) => ({
            ...prevData,
            surveyTitle: row?.surveyTitle,
            startDate: row?.startDate,
            endDate: row?.endDate,
        }));
    };

    const handleViewSurveyDashboard = (row) => {
        setSurveyTab("surveyDashboard");
        setSurveyId(row?.surveyId);
        setLanguageMasterId(row?.languageMasterId);
        setRowSurveyData(row);
    };

    const handleEditSurvey = (row, hasChildren = false) => {
        const surveyformData = {
            surveyId: row?.surveyId || 0,
            surveyTitle: row?.surveyTitle || "",
            description: row?.description || "",
            privacyNotice: row?.privacyNote || "",
            isPrivacyNoticeChecked: row?.requiredConfirmation || false,
            layoutDetails: { id: row?.surveyLayoutId } || "",
            imageDetails: { id: row?.surveyImageId } || "",
            languageId: row?.languageMasterId || "",
            isChildPresent: hasChildren || (row.languageMasterId !== 1 ? true : false),
        };
        navigate("/admin/survey/survey-page", {
            state: { storedSurveyData: surveyformData },
        });
    };
    const handlePreviewSurvey = (rowData) => {
        sessionStorage.setItem("surveyPreview", "true");
        // Navigate to the survey opening page with the row
        navigate("/user/survey/opening-page", { state: rowData });
    };

    useEffect(() => {
        const sessionLanguageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
        let languageId = 1;
        if(i18n.language === sessionLanguageDetails.name){
            languageId = sessionLanguageDetails.id;
        }
        setGlbLanguageId(languageId);
    }, [i18n.language]);

    const handleSurveyDataDownload = async (row) => {
        const surveyId = row?.surveyId;
        const languageId = glbLanguageId;
        try {
            const response = await getSurveyDataForExcel(surveyId, languageId);
            if (response?.statusCode === 200) {
                handleSurveyExportToExcel(response);
            }
        } catch (error) {
            console.error("Error downloading survey data:", error);
            toast.error(t("failedToDownloadSurveyData"), {
                position: "top-center",
            });
        }
    };

    const handleMultiSheetExcelDownload = (rowData) => {
        fetchSurveyQuestions(rowData);
    };

const handleUpload = () => {
    fetchSurveyTemplates();
    setUploadModalOpen(true);
};

const handleLanguageSelect = (e) => {
    if(e.name === "language") {
        setSelectedLang(e.value);
    }
    if(e.name === "assessmentFile") {
        handleFileChange(e);
    }
    if(e.name === "surveyTitle") {
        setSelectedSurveyId(e.value);
    }
};

const handleFileChange = (e) => {
    const file = e.files[0];
    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (file) {
      if (!validTypes.includes(e?.files[0]?.type)) {
        toast.error(t("invalidFileType"), {
          position: "top-center",
        });
        return;
      } else {
        setSelectedFile(file);
      }
    } else {
      alert("No file selected.");
    }
};


const handleUploadConfirm = async() => {
    // toast.info(`Selected language: ${selectedLang}`);
    setLoading(true);
    const requiredFields = [
        {
            label: t("selectSurveyTitle"),
            key: "Select Survey Title",
            type: "",
            value: selectedSurveyId,
        },
        {
            label: t("selectLanguage"),
            key: "Select Language",
            type: "",
            value: selectedLang,
        },
        {
            label: t("fileUpload"),
            key: "File Upload",
            type: "image",
            value: selectedFile,
        },
    ];

    let formData = {
        surveyId: selectedSurveyId,
        languageId: selectedLang,
        file: selectedFile,
    };
    const isValid = validateFields(
        formData,
        requiredFields,
        "byValue"
    );
    if (!isValid) {
        setLoading(false);
        return;
    }
    
    const payload = new FormData();
    payload.append("file", selectedFile);

    let data = {
        surveyId: selectedSurveyId,
        languageId: selectedLang,
    }

    await uploadNewSurvey(payload, data).then((response) => {
        if (response === null) {
            setUploadModalOpen(false);
        } else {
            setUploadModalOpen(false);
            fetchAllSurveys();
        }
        setLoading(false);
    });
    // Add your upload logic here using selectedLang
};

    const handleSurveyExportToExcel = (surveyData) => {
        const questions = [];
        surveyData.data[0].responses.forEach((resp) => {
            questions.push(
                `${resp.sectionTitle !== "Unknown Section Title" ? resp.sectionTitle : ""} ${resp.sectionTitle !== "Unknown Section Title" ? ":" : ""}${resp.questionText}`
            );
        });

        const rows = [questions];
        rows[0].unshift("");
        surveyData.data.forEach((user) => {
            const row = [user.userEmail];
            user.responses.forEach((resp) => {
                row.push(resp.userResponse);
            });
            rows.push(row);
        });

        const ws = XLSX.utils.aoa_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Survey Data");

        XLSX.writeFile(wb, "SurveyData.xlsx");
    };

    const onAddExtention = async () => {
        setLoading(true);
        const requiredFields = [
            {
                label: t("startDate"),
                key: "Start Date",
                type: "date",
                value: surveyFormData.startDate,
            },
            { label: t("endDate"), key: "End Date", type: "date", value: surveyFormData.endDate },
        ];

        const isValid = validateFields(
            surveyFormData,
            requiredFields,
            "byValue"
        );
        if (!isValid) {
            setLoading(false);
            return;
        }

        let payload = {
            newEnddate: surveyFormData.endDate,
            surveyId: selectedTableRow?.surveyId,
        };

        await extendSurvey(payload, selectedTableRow?.surveyId).then(
            (response) => {
                if (
                    response?.statusCode === 200 ||
                    response?.statusCode === 201
                ) {
                    toast.success(
                        `Survey ${surveyFormData?.surveyTitle} extended successfully`,
                        {
                            position: "top-center",
                        }
                    );
                    fetchAllSurveys();
                    clearPublishFields();
                    setModalOpen(false);
                }
                setLoading(false);
            }
        );
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="surveyContainer">
                    {surveyTab === "surveyManagement" ? (
                        <>
                            <div className="surveyHeader">
                                <h2 className="surveyTitle">{t("listOfSurveys")}</h2>
                                <IconButton
                                    text={t("newSurvey")}
                                    onClick={goToSurveyPage}
                                    style={{
                                        backgroundColor: "#F0F0F0",
                                        color: "#454647",
                                        border: "1px solid #B3B2B4",
                                        marginRight: "10px",
                                    }}
                                    icon={<PlusIcon />}
                                />
                                <IconButton
                                    text={t("upload")}
                                    onClick={handleUpload}
                                    style={{
                                        backgroundColor: "#F0F0F0",
                                        color: "#454647",
                                        border: "1px solid #B3B2B4",
                                        marginRight: "10px",
                                    }}
                                    icon={<PlusIcon />}
                                />

                            </div>
                            <hr />

                            <DataTableComponent
                                columns={columns}
                                data={getParentRows(tableData)} // Only parents in table
                                fullData={tableData}
                                handleAction={handleAction}
                                handlePublishAction={handlePublishAction}
                                handleRePublishAction={handleRePublishAction}
                                handleSurveyExtention={handleSurveyExtention}
                                handleSurveyDataDownload={
                                    handleSurveyDataDownload
                                }
                                handleEditSurvey={handleEditSurvey}
                                handlePreviewSurvey={handlePreviewSurvey}
                                handleViewSurveyDashboard={
                                    handleViewSurveyDashboard
                                }
                                handleSurveyTemplateDownload={
                                    handleMultiSheetExcelDownload
                                }
                                tableName="Survey"
                                onCopyLink={onCopyLink}
                                pageCount={10}
                            />
                            <ModalComponent
                                modalTitle={
                                    selectedAction === "Publish"
                                        ? t("publishSurvey")
                                        : selectedAction === "Republish"
                                            ? t("rePublishSurvey")
                                            : selectedAction === "survey_extention"
                                                ? t("surveyExtension")
                                                : modalContent?.title
                                }
                                modalText={modalText}
                                fieldsData={
                                    selectedAction === "Publish"
                                        ? surveyPublishFields
                                        : selectedAction === "Republish"
                                            ? rePublishSurveyFields
                                            : selectedAction === "survey_extention"
                                                ? surveyExtentionFields
                                                : modalContent?.fields
                                }
                                buttons={
                                    selectedAction === "Publish"
                                        ? [
                                            <button
                                                className="SurveyModalButton"
                                                onClick={() =>
                                                    onPublishSurvey()
                                                }
                                            >
                                                {" "}
                                                {t("publish")}
                                            </button>,
                                            <button
                                                className="SurveyModalButton SurveyCancel"
                                                onClick={() =>
                                                    onClosePublishModal()
                                                }
                                            >
                                                {" "}
                                                {t("cancel")}
                                            </button>,
                                        ]
                                        :
                                        selectedAction === "Republish"
                                            ? [
                                                <button
                                                    className="SurveyModalButton"
                                                    onClick={() =>
                                                        onRePublishSurvey()
                                                    }
                                                >
                                                    {" "}
                                                    {t("republish")}
                                                </button>,
                                                <button
                                                    className="SurveyModalButton SurveyCancel"
                                                    onClick={() =>
                                                        onClosePublishModal()
                                                    }
                                                >
                                                    {" "}
                                                    {t("cancel")}
                                                </button>,
                                            ]
                                            :
                                            selectedAction === "survey_extention"
                                                ? [
                                                    <button
                                                        className="SurveyModalButton"
                                                        onClick={() =>
                                                            onAddExtention()
                                                        }
                                                    >
                                                        {t("save")}
                                                    </button>,
                                                    <button
                                                        className="SurveyModalButton SurveyCancel"
                                                        onClick={() =>
                                                            onClosePublishModal()
                                                        }
                                                    >
                                                        {t("cancel")}
                                                    </button>,
                                                ]
                                                : modalContent?.buttons
                                }
                                isOpen={isModalOpen}
                                onClose={
                                    (selectedAction === "Publish" || selectedAction === "Republish")
                                        ? () => onClosePublishModal()
                                        : () => setModalOpen(false)
                                }
                                formData={selectedAction === "Republish" ? rePublishsurveyFormData : surveyFormData}
                                onChangeInput={handleInputChange}
                                onChangeDate={handleDateChange}
                                onChangeMultiselect={onChangeMultiselect}
                                modalStyle={
                                    modalContent.title === "Send Reminder" && {
                                        width: "35rem",
                                        textAlign: "left",
                                    }
                                }
                            />
                            <ModalComponent
                                isOpen={isUploadModalOpen}
                                onClose={() => setUploadModalOpen(false)}
                                modalTitle={t("uploadSurveyTemplate")}
                                fieldsData={[surveyTemplate, languageField, uploadTemplateField]}
                                formData={[{ language: selectedLang }]}
                                onChangeInput={handleLanguageSelect}
                                buttons={[<button
                                    className="SurveyModalButton"
                                    onClick={handleUploadConfirm}
                                    // disabled={!selectedLang}
                                >
                                        {t("confirm")}
                                    </button>,
                                    <button
                                        className="SurveyModalButton SurveyCancel"
                                        onClick={() => setUploadModalOpen(false)}
                                    >
                                        {t("cancel")}
                                    </button>,
                                ]}
                            />
                        </>
                    ) : (
                        surveyId && <SurveyDashboard surveyId={surveyId} languageMasterId={languageMasterId} 
                        handleSurveyDataDownload={handleSurveyDataDownload} rowSurveyData={rowSurveyData} />
                    )}
                </div>
            )}
        </>
    );
};

export default SurveyManagement;
